// extracted by mini-css-extract-plugin
export var cardIcon = "_ar-4";
export var checkboxCard = "_ar-0";
export var checkboxCardSelected = "_ar-3";
export var disabled = "_ar-1";
export var outerBorder = "_ar-2";
export var spacerMedium = "_ar-7";
export var spacerSmall = "_ar-6";
export var spacerXsmall = "_ar-5";